export enum RouteName {
  List = 'virtual-terminal-list',
}
